module.exports = __webpack_public_path__ + "static/media/bfile-annuties.96d46805.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-annuties.svg
// module id = 138
// module chunks = 0